import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5,0a5,5,0,1,0,5,5A5.006,5.006,0,0,0,5,0ZM7.277,5.416l-3,2A.5.5,0,0,1,4,7.5a.506.506,0,0,1-.236-.059A.5.5,0,0,1,3.5,7V3a.5.5,0,0,1,.777-.416l3,2a.5.5,0,0,1,0,.832Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }